import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<unknown> {
  constructor(private modalService: NgbModal) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // console.log(
    //   '[CanDeactivateGuard] hasOpenModals',
    //   this.modalService.hasOpenModals(),
    // );
    // console.log(
    //   '[CanDeactivateGuard] activeInstances',
    //   this.modalService.activeInstances,
    // );
    if (this.modalService.hasOpenModals()) {
      return false;
    }

    return true;
  }
}
